import { noop } from '@datadog/browser-core';
export function createPreStartStrategy() {
  var status = 0 /* PreStartRecorderStatus.None */;
  return {
    strategy: {
      start: function start() {
        status = 1 /* PreStartRecorderStatus.HadManualStart */;
      },
      stop: function stop() {
        status = 2 /* PreStartRecorderStatus.HadManualStop */;
      },
      isRecording: function isRecording() {
        return false;
      },
      getSessionReplayLink: noop
    },
    shouldStartImmediately: function shouldStartImmediately(configuration) {
      return status === 1 /* PreStartRecorderStatus.HadManualStart */ || status === 0 /* PreStartRecorderStatus.None */ && !configuration.startSessionReplayRecordingManually;
    }
  };
}